import {useCallback, useEffect} from "react";
import {call, delay, fork, put, race, select, take, takeEvery} from "redux-saga/effects";
import {useSelector} from "react-redux";

import {channel} from "redux-saga";
import {useSagaCallback} from "../utils/sagas";
import {useActions} from "../app_context";
import {actionEffects as actions} from "../store/actions";
import {apiExternalGet, apiExternalPostForm, plainRequest, useSagaResult} from "./client";
import useHost from "../utils/host";
import {selectLoggedIn} from "../store/selectors";
import useVisitorId from "../utils/ad_utils";

const REFRESH_INTERVAL_MS = 5 * 60 * 1000;

export function* getAd(visitorId, community) {
    const rand = Math.floor(Math.random() * 4);
    //. if (rand !== 0 || !visitorId) return false;
    // const data = yield call(apiExternalGet, 'https://ads.scored.co', `/api/fetch?publisherId=54d10583-e1c7-461c-b144-d9a6265f5848&visitorId=${visitorId}&community=${community || ''}`, new FormData());
    const data = [{"publisher_id":"54d10583-e1c7-461c-b144-d9a6265f5848","headline_text":"Supercharge Your Immune System While Supporting Dr Zelenko\u2019s Legacy","preview_image":"https://s-img.adskeeper.com/g/13054714/492x328/-/aHR0cDovL2NsLmltZ2hvc3RzLmNvbS9pbWdoL2ltYWdlL2ZldGNoL2FyXzM6MixjX2ZpbGwsZV9zaGFycGVuOjEwMCxmX2pwZyxnX2ZhY2VzOmF1dG8scV9hdXRvOmdvb2Qsd18xMDIwL2h0dHA6Ly9pbWdob3N0cy5jb20vdC8yMDIyLTA1LzEwMTkyNC9hODMxYTIxODU5NjYzNGRjODAzN2QxZjA2ODQ5Y2U5NS5qcGVn.webp?v=1661949457-z-ylrN2xn5zWkC7C2UuugQahSFP4Kz-sERdoe1ldWZc","name":"Supercharge Your Immune System While Supporting Dr Zelenko\u2019s Legacy","link":"https://zstacklife.com/?ref=scored","id":2,"full_image":"https://s-img.adskeeper.com/g/13054714/492x328/-/aHR0cDovL2NsLmltZ2hvc3RzLmNvbS9pbWdoL2ltYWdlL2ZldGNoL2FyXzM6MixjX2ZpbGwsZV9zaGFycGVuOjEwMCxmX2pwZyxnX2ZhY2VzOmF1dG8scV9hdXRvOmdvb2Qsd18xMDIwL2h0dHA6Ly9pbWdob3N0cy5jb20vdC8yMDIyLTA1LzEwMTkyNC9hODMxYTIxODU5NjYzNGRjODAzN2QxZjA2ODQ5Y2U5NS5qcGVn.webp?v=1661949457-z-ylrN2xn5zWkC7C2UuugQahSFP4Kz-sERdoe1ldWZc","click":"https://ads.scored.co/api/out?adId=2&publisherId=54d10583-e1c7-461c-b144-d9a6265f5848&uuid=9e1f4a60-0e7d-4dc5-a13f-8b3808a13787&url=https%3A%2F%2Fzstacklife.com%2F%3Fref%3Dscored","uuid":"9e1f4a60-0e7d-4dc5-a13f-8b3808a13787","extra_text":"Make Your Immune System Clean, Resilient, and Resistant."},{"publisher_id":"54d10583-e1c7-461c-b144-d9a6265f5848","headline_text":"Domain registrars are out of control - register your domains with Epik.","preview_image":"https://media.scored.co/post/c5S4aUvDneTh.jpeg","name":"Domain registrars are out of control - register your domains with Epik.","link":"https://www.epik.com/?affid=je4do4ni6","id":1,"full_image":"https://media.scored.co/post/c5S4aUvDneTh.jpeg","click":"https://ads.scored.co/api/out?adId=1&publisherId=54d10583-e1c7-461c-b144-d9a6265f5848&uuid=9067714c-a535-4b44-93c0-259226a8ecfe&url=https%3A%2F%2Fwww.epik.com%2F%3Faffid%3Dje4do4ni6","uuid":"9067714c-a535-4b44-93c0-259226a8ecfe","extra_text":"Epik are the only domain registrar that you can trust with your domains."}];
    return data[0] || false;
}

export const useAd = (loggedIn) =>
    useSagaResult(null, useCallback(() => getAd(loggedIn), [loggedIn]));

export const useAdView = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (viewId, source, format) {
        const {id} = yield call(apiExternalPostForm, 'https://ads.scored.co', `/api/view?uuid=${viewId}
        &source=${source}&publisherFormat=${format}&adId=0`, {});
        return id;
    }, []));
};

export const useAdImpression = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (viewId, source, format) {
        const {id} = yield call(apiExternalPostForm, 'https://ads.scored.co', `/api/impress?uuid=${viewId}
        &source=${source}&publisherFormat=${format}&adId=0`, {});
        return id;
    }, []));
};

function* refreshAdConfig() {
    try {
        const host = useHost();
        const response = yield call(plainRequest, {baseURL: `https://ads.scored.co/config.json?host=${host}`});
        if (response.status === 200) {
            yield actions.adConfigChanged(response.data);
        }
    } catch {
    }
}

function* fetchAdUnits() {
    try {
        const loggedIn = yield select(selectLoggedIn);
        const visitorId = useVisitorId();

        const urlParams = new URLSearchParams(location.search);
        const referrer = localStorage.getItem("referrer") || urlParams.get('ref') || urlParams.get('utm_campaign');

        const {innerWidth, innerHeight} = window;
        const host = useHost();
        const response = yield call(plainRequest, {baseURL: `https://ads.scored.co/api/load.json?site=${host === "" ? "patriots.win" : host}&loggedIn=${loggedIn}&visitorId=${visitorId}
        &width=${innerWidth}&height=${innerHeight}${referrer ? `&subId=${referrer}` : ""}`});
        if (response.status === 200) {
            yield actions.adUnitsChanged(response.data);
        }
    } catch {}
}

export function* immediate() {
    return true;
}

export function* loadAdConfigSaga() {
    const ch = channel();
    let lastRefresh = Date.now();
    yield call(refreshAdConfig);
    yield call(fetchAdUnits);
    yield fork(function* () {
        while (true) {
            try {
                const inUse = yield select(({ adConsumers }) => adConsumers > 0);
                if (inUse) {
                    const millis = REFRESH_INTERVAL_MS - (Date.now() - lastRefresh);
                    const outcome = yield race({
                        refresh: millis <= 0 ? call(immediate) : delay(millis),
                        stop: take(ch),
                    });
                    if (outcome.refresh) {
                        lastRefresh = Date.now();
                        yield call(refreshAdConfig);
                    }
                } else {
                    // Wait until in use.
                    yield take(ch);
                }
            } catch {
                // Silently ignore network errors.
                // A tight loop is not possible, all paths inside the try block do block
                // before an exception can be thrown.
            }
        }
    });
    let inUse = false;
    yield takeEvery(['adConsumerAdded', 'adConsumerRemoved'], function* () {
        const consumers = yield select(({ adConsumers }) => adConsumers);
        if (inUse !== (consumers > 0)) {
            inUse = consumers > 0;
            yield put(ch, true);
        }
    });
}

export const useAdConfig = () => {
    const actions = useActions();
    useEffect(() => {
        actions.adConsumerAdded();
        return () => actions.adConsumerRemoved();
    }, []);
    return useSelector(({ adConfig }) => adConfig);
}

export const useAdUnits = () => {
    return useSelector(({ adUnits }) => adUnits);
}

export function* getAdTag(type, width, height, path, loggedIn, adTag) {
    if (!adTag) return false;
    const domain = window.location.host;
    const data = yield call(apiExternalGet, 'https://ads.scored.co', `/api/tag?type=${type}&community=${domain}&path=${path}&guest=${!loggedIn}&width=${width}&height=${height}`, new FormData());
    return data || false;
}

export const useAdTag = (type, width, height, path, loggedIn, adTag) =>
    useSagaResult(null, useCallback(() => getAdTag(type, width, height, path, loggedIn, adTag), [type, width, height, path, loggedIn, adTag]));
